export type TypeOfRepresentativeData = {
    ErAktiv: boolean
    KortNavn: string
    Navn: string
    Sorteringsorden: number
    Type: string
    Genvalgsdato: string
    VisLangtNavnIOversigt: boolean
    SupplererMedlemsidentList: []
    SuppleresAfHvervsType: string
    SuppleresHvervsType: string
}

export class TypeOfRepresentative {
    isActive = true

    name = ''

    shortName = ''

    sort = 0

    type = ''

    showLongName = true

    electedDate = ''

    alternateRepresentativeList = [] || undefined

    supplementedOfDutyType: string | undefined

    static build(data: TypeOfRepresentativeData): TypeOfRepresentative {
        const pos = new TypeOfRepresentative()

        pos.isActive = data.ErAktiv
        pos.shortName = data.KortNavn
        pos.name = data.Navn
        pos.sort = data.Sorteringsorden
        pos.type = data.Type
        pos.showLongName = data.VisLangtNavnIOversigt
        pos.electedDate = data.Genvalgsdato
        pos.alternateRepresentativeList = data.SupplererMedlemsidentList
        pos.supplementedOfDutyType =
            data.SuppleresAfHvervsType || data.SuppleresHvervsType || undefined

        return pos
    }
}

export function mapTypeOfRepresentatives(
    data: TypeOfRepresentativeData[]
): TypeOfRepresentative[] {
    return data && data.map((pos) => TypeOfRepresentative.build(pos))
}
